import { keepPreviousData } from '@tanstack/react-query';

import type { GetQuizsetRankingsSummarySchoolType } from '@/api/gen/_model/getQuizsetRankingsSummarySchoolType';
import { useGetQuizsetRankingsSummary } from '@/api/gen/quizset-ranking/quizset-ranking.gen';
import { useCountryCode } from '@/shared/hooks';

/**
 *
 * FeaturedQuizzesAside
 * RollingBanner
 * 에서 사용
 * */
export const useFetchFeaturedQuizzesSummary = ({
  schoolType,
}: {
  schoolType: string;
}) => {
  const { isLoading, countryCode } = useCountryCode();

  const result = useGetQuizsetRankingsSummary(
    {
      ...(schoolType &&
        schoolType.toLowerCase() !== 'all' && {
          schoolType: schoolType as GetQuizsetRankingsSummarySchoolType,
        }),
      countryCode: countryCode,
    },
    {
      query: {
        enabled: !isLoading,
        placeholderData: keepPreviousData,
      },
    },
  );
  return {
    ...result,
    isLoading: isLoading || result.isLoading,
  };
};
